/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityTechResultData } from './MonitEntityTechResultData';
import {
    MonitEntityTechResultDataFromJSON,
    MonitEntityTechResultDataFromJSONTyped,
    MonitEntityTechResultDataToJSON,
} from './MonitEntityTechResultData';

/**
 * 
 * @export
 * @interface MonitEntityTechResult
 */
export interface MonitEntityTechResult {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    entity_name?: string;
    /**
     * 
     * @type {MonitEntityTechResultData}
     * @memberof MonitEntityTechResult
     */
    data?: MonitEntityTechResultData;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    tech_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityTechResult
     */
    cves?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityTechResult
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    found?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTechResult
     */
    version?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityTechResult
     */
    category?: Array<string>;
}

/**
 * Check if a given object implements the MonitEntityTechResult interface.
 */
export function instanceOfMonitEntityTechResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityTechResultFromJSON(json: any): MonitEntityTechResult {
    return MonitEntityTechResultFromJSONTyped(json, false);
}

export function MonitEntityTechResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityTechResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'data': !exists(json, 'data') ? undefined : MonitEntityTechResultDataFromJSON(json['data']),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'tech_name': !exists(json, 'tech_name') ? undefined : json['tech_name'],
        'cves': !exists(json, 'cves') ? undefined : json['cves'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'category': !exists(json, 'category') ? undefined : json['category'],
    };
}

export function MonitEntityTechResultToJSON(value?: MonitEntityTechResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'data': MonitEntityTechResultDataToJSON(value.data),
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'tech_name': value.tech_name,
        'cves': value.cves,
        'shared': value.shared,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
        'version': value.version,
        'category': value.category,
    };
}

